// extracted by mini-css-extract-plugin
export default {"dmtoggle":"toggle_dmtoggle__H82ye","moon":"toggle_moon__OwAvp","sun":"toggle_sun__hDL+c","dmcheck":"toggle_dmcheck__5e-Gg"};